/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useHUModalStyles = makeStyles(() => ({
  modal: {
    padding: '10px',
    paddingBottom: '15px',
    overflowY: 'auto',
    display: 'flex',
    // alignItems: "center",
    '&$titleDivider $header': {
      borderBottom: '2px solid #EEEEEE',
    },
  },
  paper: {
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '640px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #EEEEEE',
    borderRadius: '6px',
    margin: 'auto',
    '&:focus': {
      outline: 0,
    },
    '&$sizeTiny': {
      width: '100%',
      maxWidth: '270px',
    },
    '&$sizeSmall': {
      width: '100%',
      maxWidth: '400px',
    },
    '&$sizeMedium': {
      width: '100%',
      maxWidth: '557px',
    },
    '&$sizeBig': {
      width: '100%',
      maxWidth: '640px',
    },
    '&$sizeLarge': {
      width: '100%',
      maxWidth: '814px',
    },
    '&$sizeFullScreen': {
      width: '100%',
      maxWidth: '100%',
    },
    '&$sizeAuto': {
      width: 'auto',
    },
  },
  header: {
    padding: '15px 20px',
  },
  title: {
    textAlign: 'center',
    padding: '25px 0',
  },
  titleDivider: {},
  body: {
    padding: '10px 20px',
    flex: 1,
    overflow: 'hidden',
  },
  footer: {
    padding: '15px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *:not(:first-child)': {
      marginTop: '12px',
    },
  },
  sizeTiny: {},
  sizeSmall: {},
  sizeMedium: {},
  sizeBig: {},
  sizeLarge: {},
  sizeFullScreen: {},
  sizeAuto: {},
}));
